/**
 * Drop-in replacement for react-signature-canvas (MIT).
 * Wraps an inlined signature_pad implementation.
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import SignaturePad from './signature-pad';

class SignatureCanvas extends Component {
    static propTypes = {
        velocityFilterWeight: PropTypes.number,
        minWidth: PropTypes.number,
        maxWidth: PropTypes.number,
        minDistance: PropTypes.number,
        dotSize: PropTypes.oneOfType([PropTypes.number, PropTypes.func]),
        penColor: PropTypes.string,
        throttle: PropTypes.number,
        onEnd: PropTypes.func,
        onBegin: PropTypes.func,
        canvasProps: PropTypes.object,
        clearOnResize: PropTypes.bool,
    };

    static defaultProps = {
        clearOnResize: true,
    };

    _sigPad = null;

    _canvas = null;

    _excludeOurProps = () => {
        const { canvasProps, clearOnResize, ...rest } = this.props;
        return rest;
    };

    getCanvas = () => this._canvas;

    getSignaturePad = () => this._sigPad;

    _checkClearOnResize = () => {
        if (this.props.clearOnResize) {
            this._resizeCanvas();
        }
    };

    _resizeCanvas = () => {
        const { canvasProps = {} } = this.props;
        let { width, height } = canvasProps;

        if (!width || !height) {
            const canvas = this._canvas;
            const ratio = Math.max(window.devicePixelRatio || 1, 1);

            if (!width) {
                canvas.width = canvas.offsetWidth * ratio;
            }
            if (!height) {
                canvas.height = canvas.offsetHeight * ratio;
            }

            canvas.getContext('2d').scale(ratio, ratio);
            this.clear();
        }
    };

    on = () => {
        window.addEventListener('resize', this._checkClearOnResize);
        return this._sigPad.on();
    };

    off = () => {
        window.removeEventListener('resize', this._checkClearOnResize);
        return this._sigPad.off();
    };

    clear = () => this._sigPad.clear();

    isEmpty = () => this._sigPad.isEmpty();

    fromDataURL = (dataUrl, options) => this._sigPad.fromDataURL(dataUrl, options);

    toDataURL = (type, options) => this._sigPad.toDataURL(type, options);

    fromData = (pointGroups) => this._sigPad.fromData(pointGroups);

    toData = () => this._sigPad.toData();

    componentDidMount() {
        this._sigPad = new SignaturePad(this._canvas, this._excludeOurProps());
        this._resizeCanvas();
        this.on();
    }

    componentWillUnmount() {
        this.off();
    }

    componentDidUpdate() {
        Object.assign(this._sigPad, this._excludeOurProps());
    }

    render() {
        const { canvasProps } = this.props;

        return (
            <canvas
                ref={(ref) => {
                    this._canvas = ref;
                }}
                {...canvasProps}
            />
        );
    }
}

export default SignatureCanvas;
